// Cards for the homepage Health Portals carousel. Each links to the static
// portal served from /public/portals/<slug>/.
export const HOME_PORTALS = [
  {
    slug: 'fibromyalgia',
    name: 'Fibromyalgia',
    hub: '/portals/fibromyalgia/',
    tagline: 'Widespread pain · Fatigue · Fibro fog',
    blurb: 'FIQ-R tracking, medication comparisons, evidence-rated treatments and live research.',
    image: '/portal-covers/fibromyalgia.jpg',
  },
  {
    slug: 'css',
    name: 'Central Sensitisation',
    hub: '/portals/css/',
    tagline: 'CSI screening · Pain amplification',
    blurb: 'The 25-question CSI self-test, mechanism explainers and graded treatment evidence.',
    image: '/portal-covers/css.jpg',
  },
  {
    slug: 'long-covid',
    name: 'Long COVID & ME/CFS',
    hub: '/portals/long-covid/',
    tagline: 'PEM · Pacing · Post-viral',
    blurb: 'PEM screener, pacing guidance, symptom clusters and recruiting trials.',
    image: '/portal-covers/long-covid.jpg',
  },
  {
    slug: 'adhd',
    name: 'ADHD',
    hub: '/portals/adhd/',
    tagline: 'Attention · Executive function',
    blurb: 'Screening tools, medication and behavioural evidence, plus live ADHD research.',
    image: '/portal-covers/adhd.jpg',
  },
  {
    slug: 'arthritis',
    name: 'Arthritis',
    hub: '/portals/arthritis/',
    tagline: 'Joints · Inflammation · Mobility',
    blurb: 'OA and RA pathways, treatment evidence grades, biologics and daily management.',
    image: '/portal-covers/arthritis.jpg',
  },
  {
    slug: 'ms',
    name: 'Multiple Sclerosis',
    hub: '/portals/ms/',
    tagline: 'Relapses · MRI · DMTs',
    blurb: 'DMT comparison guide, relapse recognition, MRI context and specialist pathways.',
    image: '/portal-covers/ms.jpg',
  },
  {
    slug: 'arachnoiditis',
    name: 'Arachnoiditis',
    hub: '/portals/arachnoiditis/',
    tagline: 'Spinal nerves · Neuropathic pain',
    blurb: 'A rare-condition hub: causes, imaging, pain management evidence and live research.',
    image: '/portal-covers/arachnoiditis.jpg',
  },
];
